import { Component, OnDestroy, OnInit, AfterViewInit, NgZone } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as Handsontable from 'handsontable';
import { HotTableRegisterer } from '@handsontable/angular';

import { MatDialog } from '@angular/material/dialog';
import { MatBottomSheet } from '@angular/material/bottom-sheet';

import { WaveformComponent } from '../../components/waveform/waveform.component';
import { VersionDatepickerComponent } from '../../components/versiondatepicker/versionDatepicker.component';
import { CoverUploadComponent } from '../../components/coverupload/coverUpload.component';
import { CoverSearchComponent } from '../../components/coversearch/coverSearch.component';
import { TmdbSearchComponent } from '../../components/tmdbsearch/tmdbSearch.component';

import { Sons } from '../../ressources/types/sons';
import { WinmediaData } from '../../ressources/types/winmediaData';

import { AuthentificationService } from '../../providers/Global/authentification.service';
import { AnalyzerService } from '../../providers/Table/analyzer.service';
import { MusicsDataService } from '../../providers/Table/musicsData.service';
import { DataPassService } from '../../providers/Global/dataPass.service';
import { MysqlSyncService } from '../../providers/Global/mysqlSync.service';

import { cloneDeep } from 'lodash';
import { ChosenEditor } from './chosenEditor';

@Component({
  selector: 'app-tablesons',
  templateUrl: './tableSons.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableSonsComponent implements OnInit, OnDestroy, AfterViewInit {

  selectedWaveformSub;
  statusWaveformSub;

  selectedWaveform = 9999;

  dataFiles: Sons[] = [];

  winmediaData: WinmediaData;

  categoriesHT = [];
  categories = [];

  genreRepliques = ['Animation', 'Cinéma', 'Discours', 'Humour', 'Série', 'Sport'];

  colHeaders = ['Mix', 'Titre', 'Artiste', 'Version', 'Cover', 'Année', 'Catégorie',
    'Genre réplique', 'Stations', 'Début validité (00:00)', 'Fin validité (23:59)', 'Diffusion'];

  columns;

  dataDiffusion = ['Toujours', 'Jamais', 'Hors matinale', 'Soirée', 'Nuit (18h-7h)', 'Nuit (21h-6h)', 'Hors journée sauf Week-end', 'Hors journée sauf Dimanche', 'Samedi Dimanche Matin (7h-12h)'];

  defaultFade = 0;

  contextMenu = {
    items: {
      'info': {
        renderer: function (hot, wrapper, row, col, prop, itemValue) {
          const elem = document.createElement('marquee');
          elem.style.cssText = 'background: lightgray;';
          elem.textContent = 'Options avancées';
          return elem;
        },
        disableSelection: true,
        isCommand: false
      },
      /*'remove_row': {
        // RAJOUTER RETRAIT MIX + INACTIF SI EN COURS D'ANALYSE
        name: 'Retirer ligne(s) sélectionnée(s) [désactivé]',
        disableSelection: true, // desactivation temporaire
        isCommand: false // desactivation temporaire
      },*/
      'date_version': {
        name: 'Inscrire une date au format Winmedia',
        hidden: function () {
          return this.getColHeader(this.getSelectedLast()[1]) !== 'Version';
        },
        callback: (key, selection, clickEvent) => {
          this.zone.run(() => {
            this.setDateWinmedia(selection[0].start.row, selection[0].end.row);
          });
        }
      },
      'open_image': {
        name: 'Ouvrir l\'image',
        hidden: function () {
          return this.getColHeader(this.getSelectedLast()[1]) !== 'Cover';
        },
        callback: (key, selection, clickEvent) => {
          const cover = this.dataFiles[selection[0].start.row].son.cover?.trim();
          if (cover && cover.indexOf('http') === 0) {
            window.open(cover, '_blank');
          }
        }
      },
      'import_cover': {
        name: 'Importer une image',
        hidden: function () {
          return this.getColHeader(this.getSelectedLast()[1]) !== 'Cover';
        },
        callback: (key, selection, clickEvent) => {
          this.zone.run(() => {
            this.addCover(selection[0].start.row, selection[0].end.row);
          });
        }
      },
      'discogs': {
        name: 'Rechercher une image sur Discogs (+ année)',
        hidden: function () {
          return this.getColHeader(this.getSelectedLast()[1]) !== 'Cover';
        },
        callback: (key, selection, clickEvent) => {
          this.zone.run(() => {
            this.searchDiscogsCover(selection[0].start.row, selection[0].end.row);
          });
        }
      },
      'tmdb': {
        name: 'Rechercher une image sur TMDB (+ année et genre réplique)',
        hidden: function () {
          return this.getColHeader(this.getSelectedLast()[1]) !== 'Cover';
        },
        callback: (key, selection, clickEvent) => {
          this.zone.run(() => {
            this.searchTmdbCover(selection[0].start.row, selection[0].end.row);
          });
        }
      },
    }
  };

  private hotRegister = new HotTableRegisterer();
  hotId = 'hotInstance';

  hotSettings: Handsontable.default.GridSettings;

  constructor(private activatedRoute: ActivatedRoute,
              private authentificationService: AuthentificationService,
              private analyzerService: AnalyzerService,
              private musicsDataService: MusicsDataService,
              private dataPassService: DataPassService,
              private mysqlSyncService: MysqlSyncService,
              private matDialog: MatDialog,
              private bottomSheet: MatBottomSheet,
              private zone: NgZone) {}

  ngOnInit() {
    this.dataFiles = [];
    const files = this.dataPassService.import_files;
    const configTable = this.dataPassService.import_configTable;
    this.winmediaData = this.dataPassService.import_winmediaData;
    this.categories = this.dataPassService.import_categories;
    const cloneCategories = cloneDeep(this.categories);
    this.categoriesHT = cloneCategories.map(x => x.label);
    this.statusWaveformSub = this.dataPassService.statusWaveform.subscribe(message => {
      let i = 0;
      for (const mess of message) {
        files[i].statusWaveform = mess.status;
        if (this.dataFiles.length > 0) {
          this.dataFiles[i].status.waveformGenerated = mess.status;
        }
        i++;
      }
      if (this.dataFiles.length > 0) {
        this.hotRegister.getInstance(this.hotId).render();
      }
    });
    this.columns = [
      {
        data: 'status.general',
        width: 30,
        readOnly: true,
        // renderer: this.statusRender,
        renderer: (instance, td, row, col, prop, value, cellProperties) =>
          this.statusRender(instance, td, row, col, prop, value, cellProperties, this.dataFiles),
        className: 'htMiddle htCenter'
      },
      {
        data: 'son.title',
        width: 70,
        className: 'htMiddle htCenter',
        renderer: this.emptyClassRenderer
      },
      {
        data: 'son.performer',
        width: 70,
        className: 'htMiddle htCenter',
        renderer: this.emptyClassRenderer
      },
      {
        data: 'son.version',
        width: 50,
        className: 'htMiddle htCenter'
      },
      {
        data: 'son.cover',
        width: 50,
        renderer: (instance, td, row, col, prop, value, cellProperties) =>
          this.coverRender(instance, td, row, col, prop, value, cellProperties),
        className: 'htMiddle htCenter'
      },
      {
        data: 'son.year',
        width: 50,
        className: 'htMiddle htCenter'
      },
      {
        data: 'son.categorie',
        width: 60,
        type: 'dropdown',
        trimDropdown: false,
        source: this.categoriesHT,
        className: 'htMiddle htCenter',
        renderer: this.emptyClassRenderer
      },
      {
        data: 'son.genreRepliques',
        width: 50,
        type: 'dropdown',
        trimDropdown: false,
        source: this.genreRepliques,
        className: 'htMiddle htCenter',
        renderer: (instance, td, row, col, prop, value, cellProperties) =>
          this.emptyClassRendererGenreRepliques(instance, td, row, col, prop, value, cellProperties, this.dataFiles)
      },
      {
        editor: ChosenEditor,
        width: 60,
        data: 'son.stations',
        chosenOptions: {
          multiple: true,
          data: this.winmediaData.stations
        },
        className: 'htMiddle htCenter',
        renderer: (instance, td, row, col, prop, value, cellProperties) =>
          this.customDropdownRenderer(instance, td, row, col, prop, value, cellProperties, this.dataFiles),
      },
      {
        data: 'son.validity_beginning',
        width: 50,
        className: 'htMiddle htCenter',
        type: 'date',
        dateFormat: 'YYYY-MM-DD',
        correctFormat: true,
        renderer: (instance, td, row, col, prop, value, cellProperties) =>
          this.validityDateRenderer(instance, td, row, col, prop, value, cellProperties),
        datePickerConfig: {
          yearRange: [1960,(new Date()).getFullYear()+10],
          firstDay: 1
        }
      },
      {
        data: 'son.validity_ending',
        width: 50,
        className: 'htMiddle htCenter',
        type: 'date',
        dateFormat: 'YYYY-MM-DD',
        correctFormat: true,
        renderer: (instance, td, row, col, prop, value, cellProperties) =>
          this.validityDateRenderer(instance, td, row, col, prop, value, cellProperties),
        datePickerConfig: {
          yearRange: [1960,(new Date()).getFullYear()+10],
          firstDay: 1
        }
      },
      {
        data: 'son.diffusion',
        width: 50,
        type: 'dropdown',
        trimDropdown: false,
        source: this.dataDiffusion,
        className: 'htMiddle htCenter',
        renderer: this.emptyClassRenderer
      }
    ];
    this.setSettingsHotTable();
    this.initDataFiles(files, configTable);
    this.startAnalyzeFiles();
    this.mysqlSyncService.masquerSession(this.dataFiles[0].folder)
      .then(res => console.log(res))
      .catch(err => console.log(err));
  }

  ngAfterViewInit() {
    this.selectedWaveformSub = this.dataPassService.selectedWaveform.subscribe(message => {
      this.selectedWaveform = message;
      const select = this.dataFiles.find(p => p.position === this.selectedWaveform);
      if (select) {
        this.dataFiles[select.position].status.waveform = 1;
      } else {
        for (const el of this.dataFiles) {
          el.status.waveform = 0;
        }
      }
      this.hotRegister.getInstance(this.hotId).render();
    });
  }

  ngOnDestroy() {
    this.selectedWaveformSub.unsubscribe();
    this.statusWaveformSub.unsubscribe();
  }

  initDataFiles(files, configTable) {
    let index = 0;
    this.dataPassService.musiques_mix = [];
    let performerName = '';
    if (this.authentificationService.isLoggedInSource.getValue() === true) {
      performerName = this.authentificationService.userSource.getValue().name;
    }

    // Convertir l'ID de catégorie en label si nécessaire
    let categorieLabel = null;
    if (configTable.categorie) {
      // Si configTable.categorie est un ID (nombre ou string numérique)
      const categorieId = parseInt(configTable.categorie, 10);
      if (!isNaN(categorieId)) {
        // Chercher le label correspondant à l'ID
        const categorieObj = this.categories.find(cat => cat.id === categorieId);
        categorieLabel = categorieObj ? categorieObj.label : null;
      } else {
        // Si c'est déjà un label (string non numérique)
        categorieLabel = configTable.categorie;
      }
    }

    for (const file of files) {
      this.dataFiles.push({
        file: file.filename,
        folder: file.folder,
        position: index,
        status: {
          general: 1,
          waveform: 0,
          waveformGenerated: file.statusWaveform ? file.statusWaveform : 0
        },
        son: {
          title: file.filename,
          performer: performerName,
          categorie: categorieLabel,
          diffusion: 'Toujours'
        }
      });
      this.dataPassService.musiques_mix.push({
        file: file.filename,
        folder: file.folder,
        mix: {
          fade: this.defaultFade.toString()
        }
      });
      index++;
    }
  }

  startAnalyzeFiles() {
    const promises = [];
    let index = 0;

    console.log(this.dataFiles);

    for (const dataFile of this.dataFiles) {
      promises.push(this.setDuration(dataFile.folder, dataFile.file, index));
      index++;
    }

    Promise.all(promises)
      .then((results) => {
        console.log(results);
      });
  }

  setDuration(folder, file, index) {
    return new Promise((resolve, reject) => {
      this.analyzerService.fileMetadata(folder, file, index)
        .then(r => {
          if (r.error === 0) {
            this.dataPassService.musiques_mix[index].mix.duration = r.retour.format.duration;
            this.dataPassService.musiques_mix[index].mix.start = 0;
            this.dataPassService.musiques_mix[index].mix.mix = r.retour.format.duration - this.defaultFade;
          }
          resolve(r);
        }).catch(e => resolve(e));
    });
  }

  onAfterChange(dataChange) {
    console.log('onAfterChange');
    console.log(dataChange);
  }

  removeRow() {
    this.dataFiles.splice(1, 1);
  }

  addCover(start, end) {
    const dialogRef = this.matDialog.open(CoverUploadComponent, {
      width: '350px',
      data: {startRow: start, endRow: end},
      panelClass: 'coverPanel'
    });

    dialogRef.afterClosed().toPromise()
      .then(result => {
        if (result && result.edit) {
          for (let i = result.startRow; i <= result.endRow; i++) {
            this.dataFiles[i].son.cover = result.cover;
          }
          this.hotRegister.getInstance(this.hotId).render();
        }
      });
  }

  searchDiscogsCover(start, end) {
    let search = '';
    if (this.dataFiles[start]?.son?.performer && this.dataFiles[start]?.son?.title) {
      search = this.dataFiles[start].son.performer + ' ' + this.dataFiles[start].son.title;
    }
    const dialogRef = this.matDialog.open(CoverSearchComponent, {
      data: {startRow: start, endRow: end, search: search},
      panelClass: 'discogsPanel'
    });

    dialogRef.afterClosed().toPromise()
      .then(result => {
        if (result && result.edit) {
          for (let i = result.startRow; i <= result.endRow; i++) {
            this.dataFiles[i].son.cover = result.cover;
            if (result.year && result.year.length > 0) {
              this.dataFiles[i].son.year = result.year;
            }
          }
          this.hotRegister.getInstance(this.hotId).render();
        }
      });
  }

  searchTmdbCover(start, end) {
    let search = '';
    if (this.dataFiles[start]?.son?.performer) {
      search = this.dataFiles[start].son.performer;
    }
    const dialogRef = this.matDialog.open(TmdbSearchComponent, {
      data: {startRow: start, endRow: end, search: search},
      panelClass: 'tmdbPanel'
    });

    dialogRef.afterClosed().toPromise()
      .then(result => {
        if (result && result.edit) {
          const hot = this.hotRegister.getInstance(this.hotId);
          for (let i = result.startRow; i <= result.endRow; i++) {
            this.dataFiles[i].son.cover = result.cover;
            if (result.year && result.year.length > 0) {
              this.dataFiles[i].son.year = result.year;
            }
            if (result.album && result.album.length > 0) {
              this.dataFiles[i].son.performer = result.album;
            }
            if (result.media_type && (!this.dataFiles[i].son.genreRepliques || this.dataFiles[i].son.genreRepliques === '')) {
              let genreRepliques = null;
              if (result.media_type === 'movie') {
                genreRepliques = 'Cinéma';
              } else if (result.media_type === 'tv') {
                genreRepliques = 'Série';
              }
              if (genreRepliques) {
                hot.setDataAtRowProp(i, 'son.genreRepliques', genreRepliques);
              }
            }
          }
          hot.render();
        }
      });
  }

  coverRender(instance, td, row, col, prop, value, cellProperties) {
    const escaped = Handsontable.default.helper.stringify(value);

    if (escaped.indexOf('http') === 0) {
      const img = document.createElement('IMG') as HTMLImageElement;
      img.src = value;
      img.style.width = '40px';
      img.style.height = '40px';
      img.style.objectFit = 'contain';
      img.style.paddingTop = '4px';
      img.style.paddingBottom = '5px';
      img.style.margin = 'auto';
      img.style.display = 'block';

      Handsontable.default.dom.addEvent(img, 'mousedown', function(event) {
        event.preventDefault();
      });

      Handsontable.default.dom.empty(td);
      td.appendChild(img);
    }  else {
      Handsontable.default.renderers.TextRenderer.apply(this, arguments);
    }

    return td;
  }

  setDateWinmedia(startRow, endRow) {
    console.log(startRow, endRow);

    const dialogRef = this.matDialog.open(VersionDatepickerComponent);

    dialogRef.afterClosed().toPromise()
      .then(result => {
        console.log(result);
        if (result && result.date) {
          for (let i = startRow; i <= endRow; i++) {
            this.dataFiles[i].son.version = result.date;
          }
          this.hotRegister.getInstance(this.hotId).render();
        }
      });
  }

  statusRender(instance, td, row, col, prop, value, cellProperties, dataFiles) {
    let img = null;
    if (dataFiles && dataFiles.length > 0 && dataFiles[row].status.present_winmedia && !dataFiles[row].status.bypass_winmedia) {
      img = document.createElement('IMG');
      img.src = 'assets/icon/warning2.png';
    } else if (dataFiles && dataFiles.length > 0 && dataFiles[row].status.waveform === 1) {
      img = document.createElement('IMG');
      img.src = 'assets/icon/encoursSelected.png';
    } else {
      switch (value) {
        case 0:
          img = document.createElement('IMG');
          img.src = 'assets/icon/load.gif';
          break;
        case 1:
          img = document.createElement('IMG');
          if (dataFiles[row].status.waveformGenerated === 1) {
            img.src = 'assets/icon/encours.png';
          } else {
            img.src = 'assets/icon/encoursWait.png';
          }
          break;
        case 2:
          img = document.createElement('IMG');
          img.src = 'assets/icon/warning.png';
          break;
        case 3:
          img = document.createElement('IMG');
          img.src = 'assets/icon/sendGRAY.gif';
          break;
        case 4:
          img = document.createElement('IMG');
          img.src = 'assets/icon/send.gif';
          break;
        case 5:
          img = document.createElement('IMG');
          img.src = 'assets/icon/valid.png';
          break;
        case 6:
          img = document.createElement('IMG');
          img.src = 'assets/icon/error.png';
          break;
        default:
          img = document.createElement('IMG');
          img.src = 'assets/icon/error.png';
          break;
      }
    }

    img.width = 30;
    img.style.paddingTop = '9px';
    img.style.paddingBottom = '10px';
    img.style.margin = 'auto';
    img.style.display = 'block';

    Handsontable.default.dom.addEvent(img, 'mousedown', function(event) {
      event.preventDefault();
    });

    Handsontable.default.dom.empty(td);
    td.appendChild(img);

    return td;
  }

  customDropdownRenderer(instance, td, row, col, prop, value, cellProperties, dataFiles) {
    const optionsList = cellProperties.chosenOptions.data;

    /* Colonne stations obligatoire uniquement si catégorie "Repliques" sélectionnée */
    if ((!value || value === '') && (dataFiles[row].son.categorie === 'Répliques' || dataFiles[row].son.categorie === 'Répliques noel')) {
      td.style.background = '#CC5959';
    }

    if (typeof optionsList === 'undefined' || typeof optionsList.length === 'undefined' || !optionsList.length) {
      Handsontable.default.cellTypes.text.renderer(instance, td, row, col, prop, value, cellProperties);
      return td;
    }

    const values = (value + '').split(',');
    value = [];
    for (let index = 0; index < optionsList.length; index++) {

      if (values.indexOf(optionsList[index].id + '') > -1) {
        value.push(optionsList[index].label);
      }
    }
    value = value.join(', ');

    Handsontable.default.cellTypes.text.renderer(instance, td, row, col, prop, value, cellProperties);
    return td;
  }

  emptyClassRenderer(instance, td, row, col, prop, value, cellProperties) {
    Handsontable.default.renderers.TextRenderer.apply(this, arguments);
    if (!value || value === '') {
      td.style.background = '#CC5959';
    }
  }

  emptyClassRendererGenreRepliques(instance, td, row, col, prop, value, cellProperties, dataFiles) {
    Handsontable.default.renderers.TextRenderer.apply(this, arguments);
    /* Colonne genre réplique obligatoire uniquement si catégorie "Repliques" sélectionnée */
    if ((!value || value === '') && (dataFiles[row].son.categorie === 'Répliques' || dataFiles[row].son.categorie === 'Répliques noel')) {
      td.style.background = '#CC5959';
    }
  }

  validityDateRenderer(instance, td, row, col, prop, value, cellProperties) {
    // Appliquer d'abord le renderer de date standard
    Handsontable.default.renderers.TextRenderer.apply(this, arguments);

    // Récupérer les dates de début et de fin
    const dataRow = this.dataFiles[row];
    const beginningDate = dataRow.son.validity_beginning ? new Date(dataRow.son.validity_beginning) : null;
    const endingDate = dataRow.son.validity_ending ? new Date(dataRow.son.validity_ending) : null;

    // Vérifier si les deux dates sont définies et si la date de fin est inférieure à la date de début
    if (beginningDate && endingDate && endingDate < beginningDate) {
      td.style.background = '#CC5959'; // Fond rouge pour indiquer l'erreur
      td.title = 'La date de fin doit être supérieure à la date de début'; // Tooltip explicatif
    }
  }

  setSettingsHotTable() {
    this.hotSettings = {
      data: this.dataFiles,
      // observeChanges: true,
      afterChange: (changes) => {
        if (!changes) { return; }
        changes.forEach(([row, prop, _oldValue, newValue]) => {
          if (prop === 'son.genreRepliques' && newValue && newValue !== '') {
            if (!this.dataFiles[row].son.categorie || this.dataFiles[row].son.categorie === '') {
              this.dataFiles[row].son.categorie = 'Répliques';
              this.hotRegister.getInstance(this.hotId).render();
            }
          }
        });
      },
      afterOnCellMouseDown: (event, coords) => {
        if (coords.col === 0) {
          this.waveform(coords.row);
        }
      },
      colHeaders: this.colHeaders,
      columns: this.columns,
      contextMenu: this.contextMenu,
      stretchH: 'all',
      wordWrap: false,
      columnSorting: false,
      rowHeaders: false,
      manualColumnResize: true,
      currentRowClassName: 'currentRow',
      currentColClassName: 'currentCol',
      licenseKey: 'non-commercial-and-evaluation'
    };
  }

  waveform(pos) {
    const bottomSheetRef = this.bottomSheet.open(WaveformComponent, {
      data: {
        position: pos
      }
    });

    bottomSheetRef.afterDismissed().toPromise()
      .then((res) => {
        this.dataPassService.selectedWaveformSource.next(9999);
        if (res && res.change) {
          if (res.direction === 'next' && (pos + 1) < this.dataFiles.length) {
            this.waveform(pos + 1);
          } else if (res.direction === 'prev' && (pos - 1) >= 0) {
            this.waveform(pos - 1);
          }
        }
      });
  }

  async sendValidatedFiles() {
    const sendingData = [];
    for (const row of this.dataFiles) {
      if (row.status.general === 1 && this.checkValidatedFile(row)) {
        sendingData.push(row);
        row.status.general = 3;
      }
    }
    this.hotRegister.getInstance(this.hotId).render();
    for (const dt of sendingData) {
      await this.sendValidatedFile(dt, this.dataPassService.musiques_mix[dt.position], dt.position)
        .then(res => console.log(res))
        .catch(err => console.log(err));
    }
  }

  checkValidatedFile(row) {
    // Vérifier les champs obligatoires
    const basicValidation = row.son.title && row.son.title !== ''
      && row.son.performer && row.son.performer !== ''
      && row.son.categorie && row.son.categorie !== ''
      && row.son.diffusion && row.son.diffusion !== ''
      && ((row.son.categorie !== 'Répliques' && row.son.categorie !== 'Répliques noel')
        || (row.son.genreRepliques && row.son.genreRepliques !== ''))
      && ((row.son.categorie !== 'Répliques' && row.son.categorie !== 'Répliques noel')
        || (row.son.stations && row.son.stations !== ''));

    // Vérifier la validité des dates si elles sont renseignées
    let datesValid = true;
    if (row.son.validity_beginning && row.son.validity_ending) {
      // Vérifier que les deux dates sont au format YYYY-MM-DD
      if (!/^\d{4}-\d{2}-\d{2}$/.test(row.son.validity_beginning) || !/^\d{4}-\d{2}-\d{2}$/.test(row.son.validity_ending)) {
        datesValid = false;
      } else {
        // Convertir en objets Date pour comparer
        const beginDate = new Date(row.son.validity_beginning);
        const endDate = new Date(row.son.validity_ending);

        // Vérifier que ending est supérieur à beginning
        datesValid = endDate >= beginDate;
      }
    }

    return basicValidation && datesValid;
  }

  sendValidatedFile(dataFile, dataMix, pos) {
    console.log(dataFile);
    console.log(dataMix);
    console.log(pos);
    return new Promise((resolve, reject) => {
      this.dataFiles[pos].status.general = 4;
      this.hotRegister.getInstance(this.hotId).render();

      console.log(dataFile, dataMix);

      const user = this.authentificationService.userSource.getValue();

      this.musicsDataService.sendValidatedFilesSons(dataFile, dataMix, this.categories, this.winmediaData.stations, user)
        .then(res => {
          this.dataFiles[pos].status.general = 5;
          this.hotRegister.getInstance(this.hotId).render();
          resolve(res);
        })
        .catch(err => {
          this.dataFiles[pos].status.general = 6;
          this.hotRegister.getInstance(this.hotId).render();
          reject(err);
        });
    });
  }

}
